// extracted by mini-css-extract-plugin
export var actionText = "_r5-4";
export var container = "_r5-0";
export var leftSection = "_r5-1";
export var rightSection = "_r5-2";
export var settingsButton = "_r5-6";
export var settingsIcon = "_r5-7";
export var shortcut = "_r5-5";
export var shortcutGroup = "_r5-3";